import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CreationsPage = lazy(() => import('../pages/creations/page'));
const LivresPersonnalisesPage = lazy(() => import('../pages/livres-personnalises/page'));
const FilmsAnimationPage = lazy(() => import('../pages/films-animation/page'));
const PortraitsPage = lazy(() => import('../pages/portraits/page'));
const NouveautesPage = lazy(() => import('../pages/nouveautes/page'));
const FonctionnementPage = lazy(() => import('../pages/fonctionnement/page'));
const TarifsPage = lazy(() => import('../pages/tarifs/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const CgvPage = lazy(() => import('../pages/cgv/page'));
const MentionsLegalesPage = lazy(() => import('../pages/mentions-legales/page'));
const PolitiqueConfidentialitePage = lazy(() => import('../pages/politique-confidentialite/page'));
const MaintenancePage = lazy(() => import('../pages/maintenance/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/maintenance',
    element: <MaintenancePage />,
  },
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/creations',
    element: <CreationsPage />,
  },
  {
    path: '/livres-personnalises',
    element: <LivresPersonnalisesPage />,
  },
  {
    path: '/films-animation',
    element: <FilmsAnimationPage />,
  },
  {
    path: '/portraits',
    element: <PortraitsPage />,
  },
  {
    path: '/nouveautes',
    element: <NouveautesPage />,
  },
  {
    path: '/fonctionnement',
    element: <FonctionnementPage />,
  },
  {
    path: '/tarifs',
    element: <TarifsPage />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/produit/:id',
    element: <ProductPage />,
  },
  {
    path: '/cgv',
    element: <CgvPage />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegalesPage />,
  },
  {
    path: '/politique-confidentialite',
    element: <PolitiqueConfidentialitePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;